import { WhatsappLogo } from "@phosphor-icons/react";
import { waLink } from "../config/site";

export const WhatsAppFloat = () => {
  return (
    <a
      href={waLink("Oi! Quero garantir minha aula experimental na Templo Savassi.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Falar no WhatsApp"
      className="fixed z-50 right-5 bottom-5 flex items-center justify-center w-14 h-14 rounded-full bg-gold text-white shadow-[0_10px_30px_rgba(184,134,46,0.35)] transition-all duration-300 hover:bg-gold-dark hover:scale-105 active:scale-95"
      style={{
        right: "max(1.25rem, env(safe-area-inset-right))",
        bottom: "max(1.25rem, env(safe-area-inset-bottom))",
      }}
    >
      <WhatsappLogo size={30} weight="fill" />
    </a>
  );
};
